import { createFileRoute } from "@tanstack/react-router";
import { ProductAnalyticsSessionDetailPage } from "../../../../components/system/ProductAnalyticsSessionDetailPage";
import { requireSuperAdmin } from "../../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/product-analytics/sessions/$sessionId/")({
  beforeLoad: requireSuperAdmin(),
  component: SessionDetailRoute,
});

function SessionDetailRoute() {
  const { sessionId } = Route.useParams();
  return <ProductAnalyticsSessionDetailPage sessionId={sessionId} />;
}
